import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.agents')
  .factory('$agentAssistants', AgentAssistantsObjectFactory);

/* @ngInject */
function AgentAssistantsObjectFactory($bringozFactory: $bringozFactory,
                                      AgentsAssistantsAPI: BringozApi,
                                      AgentsAssistants_DS: DataStoreConfig) {
  function $agentAssistants(id: string) {
    return $bringozFactory(id, AgentsAssistantsAPI, AgentsAssistants_DS);
  }

  return $agentAssistants;
}
